<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
@if (!isFormSend) {
  <div class="card col-lg-3 col-11 mx-auto">
    <div class="card-body">
      <h4>Registrierung</h4>
      @if (isEmailPending) {
        <div class="card-info p-0 pending">
          <div class="card-body" style="padding-bottom: 0px;" >
            <div class="grid">
              <span class="icon-info mt-1" style="font-size: 20px"></span>
              <span style="font-size: 14px; color: white" class="mb-0">Diese E-Mail-Adresse ist bereits registriert und hat einen ausstehenden Bestätigungsstatus.</span>
              <span></span>
              <p (click)="resendEmail()" class="m-0 mb-1">Bestätigungs-E-Mail erneut senden</p>
            </div>
          </div>
        </div>
      }
      <form [formGroup]="registerForm" style="margin-top: 1.75rem" (ngSubmit)="onSubmit()">
        <label class="form-label w-100">
          Email<span class="required">*</span>
          <input type="text" formControlName="email"  (input)="onSearchQueryInput($event)"
            [style]=" isEmailExist || (registerForm.get('email')!.hasError('required') || registerForm.get('email')!.hasError('pattern')) && registerForm.get('email')!.touched ? 'padding-left: 2.25rem;' : '' "
            [ngClass]="isEmailExist || (registerForm.get('email')!.hasError('required') || registerForm.get('email')!.hasError('pattern')) && registerForm.get('email')!.touched ? 'invalid' : '' "
            class="form-control" placeholder="Ihre Email">
          @if (isEmailExist || (registerForm.get('email')!.hasError('required') || registerForm.get('email')!.hasError('pattern')) && registerForm.get('email')!.touched) {
            <i class="icon-cancel"></i>
          }
          @if (isEmailExist) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Diese E-Mail ist bereits vorhanden</span>
          }
          @if (registerForm.get('email')!.hasError('required') && registerForm.get('email')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Dieses Feld ist erforderlich.</span>
          }
          @if (registerForm.get('email')!.hasError('pattern') && registerForm.get('email')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Falsche E-Mail.</span>
          }
        </label>
        <label class="form-label w-100" style="margin-top: 0.75rem">
          Vorname<span class="required">*</span>
          <input type="text" formControlName="firstName" class="form-control" placeholder="Ihre Vorname" maxlength="40"
            [style]="(registerForm.get('firstName')!.hasError('required') || registerForm.get('firstName')!.hasError('pattern')) && registerForm.get('firstName')!.touched ? 'padding-left: 2.25rem;' : '' "
            [ngClass]="(registerForm.get('firstName')!.hasError('required') || registerForm.get('firstName')!.hasError('pattern')) && registerForm.get('firstName')!.touched ? 'invalid' : '' "
            >
          @if ((registerForm.get('firstName')!.hasError('required') || registerForm.get('firstName')!.hasError('pattern')) && registerForm.get('firstName')!.touched) {
            <i class="icon-cancel"></i>
          }
          @if (registerForm.get('firstName')!.hasError('required') && registerForm.get('firstName')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Dieses Feld ist erforderlich.</span>
          }
          @if (registerForm.get('firstName')!.hasError('pattern') && registerForm.get('firstName')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Sie können keine bestimmten Symbole im Feld vorname verwenden</span>
          }
        </label>
        <label class="form-label w-100" style="margin-top: 0.75rem">
          Nachname<span class="required">*</span>
          <input type="text" formControlName="lastName" class="form-control" placeholder="Ihre Nachname" maxlength="40"
            [style]="(registerForm.get('lastName')!.hasError('required') || registerForm.get('lastName')!.hasError('pattern')) && registerForm.get('lastName')!.touched ? 'padding-left: 2.25rem;' : '' "
            [ngClass]="(registerForm.get('lastName')!.hasError('required') || registerForm.get('lastName')!.hasError('pattern') )&& registerForm.get('lastName')!.touched ? 'invalid' : '' "
            >
          @if ((registerForm.get('lastName')!.hasError('required') || registerForm.get('lastName')!.hasError('pattern')) && registerForm.get('lastName')!.touched) {
            <i class="icon-cancel"></i>
          }
          @if (registerForm.get('lastName')!.hasError('required')  && registerForm.get('lastName')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Dieses Feld ist erforderlich.</span>
          }
          @if (registerForm.get('lastName')!.hasError('pattern') && registerForm.get('lastName')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Sie können keine bestimmten Symbole im Feld nachname verwenden</span>
          }
        </label>
        <label class="form-label w-100 mt-3">
          Passwort<span class="required">*</span>
          <div class="position-relative">
            <input noTrim [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password" class="form-control" placeholder="•••••••••••••"
                [style]="((registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched ) || registerForm.get('password')!.hasError('required')
                  || registerForm.get('password')!.hasError('minlength') || registerForm.get('password')!.hasError('requiresSpecialChars'))
                && registerForm.get('password')!.touched ? 'padding-left: 2.25rem;' : '' "
                [ngClass]="((registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched) || registerForm.get('password')!.hasError('required')
                  || registerForm.get('password')!.hasError('minlength') || registerForm.get('password')!.hasError('requiresSpecialChars'))
                && registerForm.get('password')!.touched ? 'invalid' : '' " minlength="10">
            <i class="visibility-icon my-auto"
              [class.icon-visibility-on]="!isPasswordVisible"
              [class.icon-visibility-off]="isPasswordVisible"
              (click)="isPasswordVisible = !isPasswordVisible">
            </i>
            @if (((registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched) || registerForm.get('password')!.hasError('required')
              || registerForm.get('password')!.hasError('minlength') || registerForm.get('password')!.hasError('requiresSpecialChars'))
              && (registerForm.get('password')!.touched || registerForm.get('passwordConfirm')!.touched)) {
              <i class="icon-cancel"></i>
            }
          </div>
          @if (registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched
            && !registerForm.get('password')!.hasError('minlength') && !registerForm.get('password')!.hasError('minlength')
            && !registerForm.get('password')!.hasError('requiresSpecialChars')) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Die Passwörter sollten gleich sein</span>
          }
          @if (registerForm.get('password')!.hasError('required') && registerForm.get('password')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Dieses Feld ist erforderlich.</span>
          }
          @if (registerForm.get('password')!.hasError('minlength') && registerForm.get('password')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Ein Passwort muss aus mindestens zehn Zeichen bestehen.</span>
          }
          @if (registerForm.get('password')!.hasError('requiresSpecialChars') && registerForm.get('password')!.touched && !registerForm.get('password')!.hasError('minlength')) {
            <span style="color: red; font-size: 12px; font-weight: 600;">Das Passwort sollte mindestens ein Sonderzeichen enthalten.</span>
          }
        </label>
        <label class="form-label w-100 mt-3">
          Passwort bestätigen<span class="required">*</span>
          <div class="position-relative">
            <input noTrim [type]="isPasswordConfirmVisible ? 'text' : 'password'" formControlName="passwordConfirm" class="form-control" placeholder="•••••••••••••"
              [style]=" registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched ? 'padding-left: 2.25rem;' : '' "
              [ngClass]="registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched ? 'invalid' : '' ">
            <i class="visibility-icon my-auto"
              [class.icon-visibility-on]="!isPasswordConfirmVisible"
              [class.icon-visibility-off]="isPasswordConfirmVisible"
              (click)="isPasswordConfirmVisible = !isPasswordConfirmVisible">
            </i>
            @if (registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched) {
              <i class="icon-cancel"></i>
            }
          </div>
          @if (registerForm.errors?.['passwordMatching'] && registerForm.get('passwordConfirm')!.touched) {
            <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Die Passwörter sollten gleich sein</span>
          }
        </label>
        <button type="submit" class="btn btn-primary d-block mx-auto submit-button" [disabled]="registerForm.invalid || isEmailExist">Registrieren</button>
      </form>
    </div>
  </div>
}
@if (isFormSend) {
  <div style="margin-top: 8rem;" class="card col-lg-3 col-11 mx-auto">
    <div class="card-body">
      <div class="text-center">
        <h4>Registrierung fast abgeschlossen</h4>
        <div class="check-email-message" style="margin-top: 1.75rem">
          <div class="grid">
            <span class="icon-check-circle mt-1" style="font-size: 20px"></span>
            <span style="font-size: 14px;" class="mb-0">
              Wir haben Ihnen eine E-Mail mit dem Aktivierungslink für Ihr Konto geschickt, bitte überprüfen Sie Ihr Postfach.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (!isFormSend) {
  <div class="text-center mt-md-4 link">
    <span class="link-btn" (click)="GoToForgotPassword()">Passwort vergessen </span> |
    <span class="link-btn" (click)="GoToLogin()"> Anmeldung</span>
  </div>
}
@if (isFormSend) {
  <div class="text-center mt-md-4 link">
    <span class="link-btn" (click)="GoToLogin()">Zurück zum Login</span>
  </div>
}
<div class="text-center">
  <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank" class="link-btn no-decoration">Datenschutzerklärung</a> <span class="link-btn"> |</span>
  <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" class="link-btn no-decoration ml-1">Impressum </a>
</div>

